module.exports = __webpack_public_path__ + "img/bg.7fbcee4d.jpeg";